export const isDistributorDomain = (hostname) => {
  if (!hostname) return false;
  const host = hostname.split(':')[0]; // strip port
  if (host === 'localhost') return false;
  if (host === 'envelope.so' || host.endsWith('.envelope.so')) return false;
  if (host.endsWith('.vercel.app')) return false;
  return true;
};
